module.exports = __webpack_public_path__ + "img/mzzg4.d9b992aa.jpg";